interface SpinnerProps {
  size?: number;
}

export default function Spinner({ size = 16 }: SpinnerProps) {
  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        flex: 'none',
        display: 'inline-block',
        borderRadius: '50%',
        border: '2px solid var(--line-2)',
        borderTopColor: 'var(--accent)',
        animation: 'spin 0.8s linear infinite',
      }}
    />
  );
}
